import React from 'react';
import { Form, Button, Input, Col, Row, message, Table } from 'antd';
import ModalDom from '../../../../components/Modal';
import DetailTitle from '../../../../components/DetailTitle/index';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { postFrom, config } from '../../../../axios';
import { dicPayChannel, dicPayType, liuShuiMeiJu } from '../../../../axios/dictionaries';
import moment from 'moment'
import { moneyAddComma } from '../../../../utils/index'

class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            data: {}
        }
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    loadPackage = (id) => {
        this.setState({ loading: true });
        let data = { tradeRecordId: id };
        postFrom({ url: config.API_traderecord_getById, data }).then(res => {
            this.setState({ data: res, loading: false });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        })
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
        })
    }

    render() {
        let { visible, handleCancel, form: { getFieldDecorator } } = this.props;
        let {
            loading,
            data,
        } = this.state;

        const tradeRecordLedgerDetailColumns = [
            { title: '商户号', dataIndex: 'mid' },
            { title: '分账比例', dataIndex: 'scale' },
        ]

        let dicPayChannels, dicPayTypes, businessStatess;
        // data.tradeRecord ? data.tradeRecord.map((item, index) => { //支付渠道

        // }) : null
        dicPayChannels = dicPayChannel.find(item1 => data.payChannel === item1.value)
        dicPayTypes = dicPayType.find(item1 => data.payType === item1.value)
        businessStatess = liuShuiMeiJu.find(item1 => data.status === item1.value)

        return <ModalDom
            title="收款详情 【流水】"
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={handleCancel}
            footer={
                <div>
                    {/* <Button type="primary" loading={loading}>打印</Button> */}
                    <Button onClick={handleCancel}>关闭</Button>
                </div>
            }
               >
            <div className="custom">
                <Form labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                >
                    <Row>
                        {/* <Col>
                            <DetailTitle title="房源" boxStyle={{ marginTop: 0 }} />
                            <CustomRow>
                                <CustomCol label="楼栋/楼盘" required={false} >
                                    {getFieldDecorator('faceDetected', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.buildingName ? data.buildingName : null
                                    })(
                                        <Input
                                            placeholder={'请输入'} disabled={true}
                                            autoComplete={'off'}

                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="房间号" required={false} >
                                    {getFieldDecorator('faceDetected', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.buildingName ? data.buildingName : null
                                    })(
                                        <Input
                                            placeholder={'请输入'} disabled={true}
                                            autoComplete={'off'}

                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                        </Col> */}
                        <Col>
                            <DetailTitle title="租客" boxStyle={{ marginTop: 0 }} />
                            <CustomRow>
                                <CustomCol label="姓名" required={false} >
                                    <Input
                                        disabled
                                        value={data.customerName}
                                    />
                                </CustomCol>
                                <CustomCol label="证件号码" required={false} >
                                    <Input
                                        disabled
                                        value={data.credentialNumber}
                                    />
                                </CustomCol>
                                <CustomCol label="手机号码" required={false} >
                                    <Input
                                        disabled
                                        value={data.customerPhone}
                                    />
                                </CustomCol>
                            </CustomRow>
                        </Col>
                        {
                          data.platformAmount || data.subAmount ? (
                            <Col>
                              <DetailTitle title="分账信息" boxStyel={{ marginTop: 0 }} />
                              <CustomRow>
                                <CustomCol label="平台商户金额" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>} >
                                  <Input
                                    disabled
                                    value={data.platformAmount}
                                  />
                                </CustomCol>
                                <CustomCol label="子商户金额" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>} >
                                  <Input
                                    disabled
                                    value={data.subAmount}
                                  />
                                </CustomCol>
                              </CustomRow>
                              <CustomRow divider>
                                <CustomCol label="分账比例说明" required={false} colStyle={{ width: 800,height: 80 }} >
                                  <Input.TextArea
                                    style={{ height: '100%' }}
                                    disabled
                                    value={data.subAccountDesc}
                                  />
                                </CustomCol>
                              </CustomRow>
                              <Table bordered pagination={false} columns={tradeRecordLedgerDetailColumns} dataSource={data.tradeRecordLedgerDetailList} />
                            </Col>
                          ) : null
                        }
                        <Col>
                            <DetailTitle title="收款" />
                            <CustomRow>
                                <CustomCol label="交易金额" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>} >
                                    <Input
                                        disabled
                                        value={moneyAddComma(data.amount)}
                                    />
                                </CustomCol>
                                <CustomCol label="交易渠道" required={false} >
                                    <Input
                                        disabled
                                        value={dicPayChannels ? dicPayChannels.title : ''}
                                    />
                                </CustomCol>
                                <CustomCol label="交易方式" required={false}  >
                                    <Input
                                        disabled
                                        value={dicPayTypes ? dicPayTypes.title : ''}
                                    />
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="交易时间" required={false} >
                                    <Input
                                        disabled
                                        value={data.tradeTime ? moment(data.tradeTime).format('YYYY-MM-DD') : ''}
                                    />
                                </CustomCol>
                                <CustomCol label="交易状态" required={false}  >
                                    <Input
                                        disabled
                                        value={businessStatess ? businessStatess.title : ''}
                                    />
                                </CustomCol>
                            </CustomRow>
                        </Col>
                        {
                            data.tradeRecordPaylog instanceof Array && data.tradeRecordPaylog.length !== 0 ?
                                <Col>
                                    <DetailTitle title="账单" />
                                    <div className="tableBox">
                                        <div className="tableTitle">
                                            <div style={{ flex: 1 }}>应收日期</div>
                                            <div style={{ flex: 1 }}>房源</div>
                                            <div style={{ flex: 1 }}>账单名称</div>
                                            <div style={{ flex: 1 }}>账单周期</div>
                                            <div style={{ flex: 1 }}>应收金额（元）</div>
                                            <div style={{ flex: 1 }}>核销日期</div>
                                            <div style={{ flex: 1 }}>核销金额（元）</div>
                                            <div style={{ flex: 1 }}>优惠金额（元）</div>
                                        </div>
                                        <div className="tableBody">
                                            {
                                                data.tradeRecordPaylog.map((item, index) => {
                                                    return (
                                                        <div className="tableBodyRow" key={item.id}>
                                                            <div style={{ flex: 1 }}>{item.mustPayDate ? moment(item.mustPayDate).format('YYYY-MM-DD') : null}</div>
                                                            <div style={{ flex: 1, flexDirection: "column" }}>
                                                                <div>
                                                                    {item.roomNo ? item.roomNo : null}
                                                                </div>
                                                                <div>
                                                                    {item.buildingName ? item.buildingName : null}
                                                                </div>
                                                            </div>
                                                            <div style={{ flex: 1 }}>
                                                                {item.billFeeName ? item.billFeeName : null}
                                                            </div>
                                                            <div style={{ flex: 1, flexDirection: "column" }}>
                                                                <div>
                                                                    {item.billBeginDate ? moment(item.billBeginDate).format('YYYY-MM-DD') : null}
                                                                </div>
                                                                <div>
                                                                    {item.billEndDate ? moment(item.billEndDate).format('YYYY-MM-DD') : null}
                                                                </div>
                                                            </div>
                                                            <div style={{ flex: 1 }}>
                                                                {item.billMoney ? moneyAddComma(item.billMoney) : null}
                                                            </div>
                                                            <div style={{ flex: 1 }}>{
                                                                item.createTime ? moment(data.createTime).format('YYYY-MM-DD') : null
                                                            }</div>
                                                            <div style={{ flex: 1, color: "red" }}>{
                                                                item.amount ? moneyAddComma(item.amount-(item.creditAmount==null?0:item.creditAmount)) : null
                                                            }</div>
                                                            <div style={{ flex: 1, color: "red" }}>{
                                                                item.amount ? moneyAddComma(item.creditAmount) : null
                                                            }</div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </Col>
                                : null
                        }
                    </Row>
                </Form>
            </div>
        </ModalDom>
    }


}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/Payment/components/Detailed/Detail.js